export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-puzzle-b046d9d005f0646ed17c77164e030d02.svg";